import { render } from "./FooterNWI.vue?vue&type=template&id=a9da1abe&scoped=true"
import script from "./FooterNWI.vue?vue&type=script&lang=js"
export * from "./FooterNWI.vue?vue&type=script&lang=js"

import "./FooterNWI.vue?vue&type=style&index=0&id=a9da1abe&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2988073122/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9da1abe"]])

export default __exports__